<template>
    <v-menu
        v-if="menuData"
        top
        left
        attach
        offset-y
        :close-on-content-click="closeOnContentClick"
        rounded="lg"
        min-width="250px"
        max-width="300px"
        transition="scale-transition"
        origin="bottom right"
    >
        <template #activator="{ on: menu, attrs }">
            <v-tooltip
                top
                attach
                min-width="max-content"
            >
                <template #activator="{ on: tooltip }">
                    <v-btn
                        icon
                        large
                        v-bind="attrs"
                        v-on="{ ...tooltip, ...menu }"
                    >
                        <v-icon large :color="mainColor">
                            mdi-menu
                        </v-icon>
                    </v-btn>
                </template>
                <span>Μενού</span>
            </v-tooltip>
        </template>
        <v-list>
            <v-list-item
                v-for="(item, index) in menuData.template.persistent_menu[0].call_to_actions"
                :key="index"
                @click="clickMenu(item)"
                class="text-start"
            >
                <v-list-item-title
                    class="text-subtitle-1 pl-1"
                >
                    {{ item.title }}
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
    export default {
        props: {
            menuData: {
                type: Object,
                default: null
            },
            mainColor: {
                type: String,
                default: null
            }
        },
        data: () => ({
            closeOnContentClick: true
        }),
        methods: {
            clickMenu(item) {
                if (item.url) {
                    window.open(item.url, '_blank', 'noreferrer');
                } else {
                    this.$emit('prepareMessage', {
                        text: item.payload,
                        freshchatAgentText: item.title
                    });
                }
            }
        }
    }
</script>